import React from 'react';
import { Box, Typography } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';
import TeamDarkButtonWithIcon from 'team/shared/components/button/TeamDarkButtonWithIcon';

const TeamApiKeysHeader = ({ count, onCreate }) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mb: 3,
            mt: 1
        }}>
            <TeamDarkButtonWithIcon
                icon={<AddIcon />}
                text="Create API Key"
                onClick={onCreate}
                sx={{
                    borderRadius: '20px',
                    paddingX: 3,
                    paddingY: 1,
                    fontSize: '0.7rem'
                }}
            />
        </Box>
    );
};

export default TeamApiKeysHeader;
